<template>
  <div class="StaffManage-list">
    <GlobalInfoBar
        title="分类列表"
        content="分类列表"
    />
    <GlobalChunk
        icon="search"
        title="筛选查询"
    >
      <div slot="filter">
        <CategoryForm :byRoleList="byRoleList" />
      </div>
      <CategoryTable :byRoleList="byRoleList"/>
      
    </GlobalChunk>

  </div>
</template>

<script>
import CategoryForm from './From'
import CategoryTable from './Table'
import _api from "@/utils/request";
export default {
  name: 'StaffManage-list',
  components: {CategoryForm,CategoryTable},
  data(){
    return{
      roleId:"",
      clickShow: '01',
      byRoleList: [],
      baseRequest1: null,
      baseRequest2: null,
      firstShow: true,
    }
  },
  created(){
    this.roleSelectByRole()
    this.BtnClick('active')
  },
  methods:{
    BtnClick(type){
      if(type == 'active' && this.clickShow=='01' && !this.firstShow){
        return false
      }
      if(type == 'before' && this.clickShow=='02'){
        return false
      }
      if(this.firstShow){
        this.firstShow = false
      }
      console.log(this.$store.state.tagsView.SeachParams);
      let SeachParams = this.$store.state.tagsView.SeachParams
      console.log(SeachParams);
      if(type==='active'){
        this.clickShow='01'
      }else{
        this.clickShow='02'
      }
      if(SeachParams.type == '01'){
        this.baseRequest1={
          roleId:SeachParams.roleId || '',
          staffName: SeachParams.staffName || '',
          staffMobile: SeachParams.staffMobile || '',
          type:'01',
          pageNum: 1,
          pageSize: 10,
        }
      }else{
        this.baseRequest2 = {
          staffName: SeachParams.staffName || '',
          staffMobile: SeachParams.staffMobile || '',
          staffType: SeachParams.staffType || '',
          storeId: SeachParams.storeId || '',
          type:'02',
          pageNum: 1,
          pageSize: 10,
        }
      }
      const baseRequest = {
        roleId:"",
        staffName: "",
        staffMobile: "",
        staffType: "",
        storeId: "",
        type:this.clickShow,
        pageNum: 1,
        pageSize: 10,
      };
      console.log(this.baseRequest1, this.baseRequest2);
      if(SeachParams.type == '01'){
        if(this.baseRequest2 == null){
          this.$store.commit('tagsView/SEACH_PARAMS',baseRequest)
        }else{
          this.$store.commit('tagsView/SEACH_PARAMS',this.baseRequest2)
        }
      }else{
        if(this.baseRequest1 == null){
          this.$store.commit('tagsView/SEACH_PARAMS',baseRequest)
        }else{
          this.$store.commit('tagsView/SEACH_PARAMS',this.baseRequest1)
        }
      }
    },
    roleSelectByRole() {
      _api.roleSelectByRole().then(res => {
        console.log(res);
        this.byRoleList = res.data
      })
    },
  },
  beforeDestroy() {
    this.$store.commit('tagsView/SEACH_PARAMS',{})
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.StaffManage-list{
  .button_top{
    cursor: pointer;
    margin-bottom: 20px;;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn{
    width: 280px;
    height: 42px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    .left{
    text-align: center;
    color: white;
    width: 50%;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 42px;
    height: 42px;
    background: #0981ff;
    border-radius: 20px 0 0 20px;
    }

    .left2 {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 42px;
      height: 42px;
      background: #0981ff;
      border-radius: 0 20px 20px 0;
    }  

    .right{
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 42px;
      height: 42px;
      border-radius: 20px;
    }
  }
}
</style>
